import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DecimalPipe } from "@angular/common";
import { TfBlockUIService } from "@app/modules/tf-block-ui";
import { ProductsService } from '@app/services/products.service';
import { StoreService } from "@app/services/store.service";
import { AnalyticsService } from '@app/services/analytics.service';
import { ProductSiteRegionService } from '@app/services/product-site-region.service';
import { SearchStatusEnum } from "@app/models/enums/search-status.enum";
import { Subscription } from "rxjs";

@Component({
    selector: 'tf-search-footer',
    templateUrl: './search-footer.component.html',
    styleUrls: ['./search-footer.component.scss']
})
export class TfSearchFooterComponent implements OnInit, OnDestroy {

    @Input() totalHits: number;
    @Input() currentProductsLength: number;
    @Input() customArray: boolean;

    defaultLimit = 25;

    private subscriptions: Subscription = new Subscription();

    constructor(
        private analyticsService: AnalyticsService,
        private blockUIService: TfBlockUIService,
        private storeService: StoreService,
        private decimalPipe: DecimalPipe,
        private productSiteRegionService: ProductSiteRegionService,
        private productsService: ProductsService

    ) {
    }

    ngOnInit(): void {
        this.subscribeToSearchStatus();
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    subscribeToSearchStatus() {

        const subscription = this.storeService.searchStatus$.subscribe((status) => {

            if (status === SearchStatusEnum.loadingMore || status === SearchStatusEnum.searching) {
                this.blockUIService.start();
            } else {
                this.blockUIService.stop();
            }

        });

        this.subscriptions.add(subscription);

    }

    incrementOffset() {
        this.storeService.handleLoadMore();
        this.triggerAnalytics();
    }

    triggerAnalytics() {
        this.analyticsService.loadMoreClicked();
    }

    getResultLabel() {
        const currentProducts = this.decimalPipe.transform(this.currentProductsLength || 0);
        const totalHits = this.decimalPipe.transform(this.totalHits || 0);
        let resultLabel = `Viewing ${currentProducts} of ${totalHits} result`;
        if (this.totalHits > 1) {
            resultLabel += 's';
        }
        return resultLabel;
    }

    hasLoadMore() {
        return this.currentProductsLength !== this.totalHits;
    }

    getButtonLabel() {
        const remainProducts = this.totalHits - this.currentProductsLength;
        const resultCount = remainProducts > this.defaultLimit ? this.defaultLimit : remainProducts;

        return `Load ${resultCount || 0} more results`;
    }

    showNotFindingLink(): boolean {
            const isFisherSci = this.productSiteRegionService.isFisherSci();
            const isB2B = this.productsService.isUserTypeB2B();
            return !(isFisherSci && isB2B);
    }

    getUrl() {
        if (this.productSiteRegionService.isFisherSci() == true) {
            return `/store1/configurators/?disableConfig=true&confType=LSG&store=Scientific&storeId=10652&origin=button&page=other-tools/applied-biosystems-taqman-primer-design-tools`;
        }
        return window.location.origin + "/order/custom-genomic-products/tools/cadt/";
    }
}
